import request from '@/utils/request'
import qs from 'qs'

export function receivablesList(params) {
  return request({
    url: '/crm/Receivables/receivablesList',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function readReceivablesList(params) {
  return request({
    url: '/crm/Receivables/readReceivablesList',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function addReceivables(params) {
  return request({
    url: '/crm/Receivables/addReceivables',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function delReceivables(params) {
  return request({
    url: '/crm/Receivables/delReceivabless',
    method: 'POST',
    data: qs.stringify(params)
  })
}

export function editReceivables(params) {
  return request({
    url: '/crm/Receivables/editReceivables',
    method: 'POST',
    data: qs.stringify(params)
  })
}









